import Customer from 'src/models/customer'
import { date } from 'quasar'
import { distanceInWords } from 'src/utils/date'
import { formatMoney } from 'src/utils/format'
import i18n from 'src/i18n/i18n'

export function transformActivity (activity) {
  return {
    date: getActivityDate(activity),
    title: getActivityTitle(activity),
    description: getActivityDescription(activity),
    icon: getActivityIcon(activity),
    timePassed: distanceInWords(activity.created_at.date),
    createdAt: activity.created_at.date,
    url: getActivityUrl(activity),
    tag: getActivityTag(activity)
  }
}

export function getActivityIcon (activity) {
  const map = {
    'invoice_created': 'add',
    'quote_created': 'add',
    'expense_created': 'add',
    'importedinvoice_created': 'add',
    'invoice_email_sent': 'email',
    'quote_email_sent': 'email',
    'invoice_payment_created': 'payment',
    'invoice_payment_deleted': 'payment',
    'invoice_status_changed': 'local_offer',
    'quote_status_changed': 'local_offer',
    'invoice_updated': 'edit',
    'quote_updated': 'edit',
    'invoice_mail_failed': 'warning',
    'quote_email_failed': 'warning',
    'invoice_committed': 'lock',
    'quote_committed': 'lock',
    'expense_committed': 'lock'
  }

  return map.hasOwnProperty(activity.activity_type) ? map[activity.activity_type] : null
}

export function getActivityTitle (activity) {
  return i18n.t(`activities_${activity.activity_type}_title`)
}

export function getActivityDescription (activity) {
  return i18n.t(`activities_${activity.activity_type}_description`, transformPropertiesForActivity(activity))
}

export function getActivityDate (activity) {
  return date.formatDate(activity.created_at.date, i18n.t('date_time_format'))
}

export function getActivityTag (activity) {
  if (!activity.subject) {
    return null
  }

  if (activity.subject_type === 'invoice') {
    return activity.subject.data.invoice_number
      ? `#${activity.subject.data.invoice_number}`
      : (new Customer(activity.subject.data.customer.data)).getName()
  } else if (activity.subject_type === 'expense' && activity.subject.data.supplier) {
    return (new Customer(activity.subject.data.supplier.data)).getName()
  } else if (activity.subject_type === 'quote') {
    return activity.subject.data.quote_number
      ? `#${activity.subject.data.quote_number}`
      : (new Customer(activity.subject.data.customer.data)).getName()
  }

  return null
}

export function getActivityUrl (activity) {
  if (!activity.subject) {
    return null
  }

  if (activity.subject_type === 'invoice') {
    return {
      name: activity.subject.data.status === 'draft' ? 'edit-invoice' : 'invoice',
      params: { invoice: activity.subject_id, teamId: activity.team_id }
    }
  } else if (activity.subject_type === 'quote') {
    return {
      name: activity.subject.data.status === 'draft' ? 'edit-quote' : 'quote',
      params: { quote: activity.subject_id, teamId: activity.team_id }
    }
  } else if (activity.subject_type === 'expense') {
    return { name: 'expense', params: { expenseId: activity.subject_id, teamId: activity.team_id } }
  }

  return null
}

export function transformPropertiesForActivity (activity) {
  if (!activity.properties) {
    return {}
  }

  try {
    const map = {
      'invoice_email_sent': () => ({ recipient: activity.properties.recipient }),
      'quote_email_sent': () => ({ recipient: activity.properties.recipient }),
      'invoice_payment_created': () => ({ amount: formatMoney(activity.properties.data.model_data.balance) }),
      'invoice_payment_deleted': () => ({ amount: formatMoney(activity.properties.data.model_data.balance) }),
      'invoice_status_changed': () => ({ status: i18n.t(activity.properties.data.model_data.status_code) }),
      'expense_payment_created': () => ({ amount: formatMoney(activity.properties.data.model_data.balance) }),
      'expense_payment_deleted': () => ({ amount: formatMoney(activity.properties.data.model_data.balance) }),
      'quote_status_changed': () => ({ status: i18n.t(activity.properties.data.model_data.status_code) }),
      'invoice_email_failed': () => ({ address: activity.properties.address }),
      'quote_email_failed': () => ({ address: activity.properties.address })
    }

    return map.hasOwnProperty(activity.activity_type) ? map[activity.activity_type]() : activity.properties
  } catch (e) {
    console.error(e)
  }
}
